import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppDispatch } from '../data/store';
import { loginSuccess } from '../data/stores/authStore';
import { baseAxiosClient } from '../clients/axios-client';
import { User } from '../data/models/user';
import ScreenContainer from './common/layout/ScreenContainer';
import CenterContainer from './common/layout/CenterContainer';
import Config from '../config';
import { showAlert } from '../data/stores/alertStore';

export default function OAuth2CallbackScreen() {
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();
	const hasHandledRef = useRef(false);

	useEffect(() => {
		if (hasHandledRef.current) return;
		// Extract the code from URL query parameters
		const queryParams = new URLSearchParams(location.search);
		const code = queryParams.get('code');
		const state = queryParams.get('state');

		const handleOAuth2Callback = async (
			code: string,
			state: {
				isSignup: boolean;
				accountType: 'gmail' | 'workspace' | null;
			} | null
		) => {
			const { isSignup, accountType } = state || {
				isSignup: false,
				accountType: null,
			};
			try {
				const response: { user: User; astroToken: string } =
					await baseAxiosClient({
						url: `${Config.apiBaseUrl}/user/oauth2callback`,
						method: `POST`,
						withCredentials: true,
						headers: {
							'X-Client-Type': 'web',
						},
						data: {
							code,
							isSignup,
							accountType,
						},
					});
				dispatch(
					loginSuccess({
						user: response.user,
						astroToken: response.astroToken,
					})
				);
				if (isSignup) {
					navigate('/signup-company');
				} else {
					navigate('/login');
				}
			} catch (error: any) {
				console.log('error', error);
				navigate('/');
				if (isSignup) {
					dispatch(
						showAlert({
							message: error,
							severity: 'error',
						})
					);
				} else {
					dispatch(
						showAlert({
							message:
								'An error occurred logging in, please check your credentials and try again.',
							severity: 'error',
						})
					);
				}
			}
		};
		if (code) {
			hasHandledRef.current = true;
			handleOAuth2Callback(
				code,
				state
					? JSON.parse(state)
					: { isSignup: false, accountType: null }
			);
		}
	}, [location, navigate, dispatch]);

	return (
		<ScreenContainer>
			<CenterContainer>
				<h2>Getting the Orbito Universe ready for you...</h2>
			</CenterContainer>
		</ScreenContainer>
	);
}
